import classNames from 'classnames';

import { Cell } from '@/explore/types';
import { SortableItemSimple } from '@/explore/components/sortable-item';
import { Icon } from '@/components/icon';

import styles from './exploration-outline.module.scss';

export const getCellTitle = (cell: Cell) =>
  cell.kind === 'text'
    ? 'Text block'
    : 'title' in cell
      ? cell.title !== ''
        ? cell.title
        : '(Untitled Block)'
      : cell.kind === 'variable'
        ? cell.definition.key
        : '(Untitled Block)';

type CellItemProps = {
  cell: Cell;
  index: number;
  draggedIndex: number | null;
  setDraggedIndex: (index: number | null) => void;
  onMove: (fromIndex: number, toIndex: number) => void;
  onClickCell: (cellId: string) => void;
  tabId?: string;
};

export const CellItem = ({
  cell,
  index,
  draggedIndex,
  setDraggedIndex,
  onMove,
  onClickCell,
  tabId,
}: CellItemProps) => {
  return (
    <SortableItemSimple
      key={index}
      scope={`exploration-outline-cells-${tabId}`}
      index={index}
      draggedIndex={draggedIndex}
      setDraggedIndex={setDraggedIndex}
      onReorder={onMove}
      className={classNames(styles.cellItem, styles.sortableItem)}>
      <Icon name="DragHandle" size={10} className={styles.sortHandle} />
      <a onClick={() => onClickCell(cell.id)}>{getCellTitle(cell)}</a>
    </SortableItemSimple>
  );
};
